export default "__VITE_ASSET__Dfdkxwcq__"